module.exports = __webpack_public_path__ + "static/media/sharegroup.a8bc93f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/modules/theme/components/images/sharegroup.png
// module id = 977
// module chunks = 0